import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectVideoState = (state: RootState) => state.Video || initialState

export const videoSelector = createSelector([selectVideoState], Video => Video)
